export default "__VITE_ASSET__Bcsr2qQI__"